module.exports = __webpack_public_path__ + "static/media/portfolio_thumb.f20b02aa.png";